<template>
  <!-- 登录首页 -->
  <div>
    <loadingPage v-if="loadingWechat" style="height:100vh"></loadingPage>
    <div class="index" v-else>
      <div class="content" >
        <Row :gutter="20">
          <Col span="19">
            <Carousel autoplay :autoplay-speed="3000" height:500px>
              <Carousel-item v-for="(item, i) in adList" :key="i">
                <div @click="handleAd(item)">
                  <img :src="item.bannerCover" alt="" class="bannerImg" />
                </div>
              </Carousel-item>
            </Carousel>
          </Col>
          <Col span="5">
            <div class="avatar">
              <!-- <img src="../assets/default.png" /> -->
              <p class="tip">
                <span>每个孩子都有机会学习编程</span><br />
                <span>-----源码熊 </span>
              </p>
              <div class="btn_bg">
              </div>
              <div class="loginBtn" @click="toLogin">{{ loginText }}</div>
              <!-- <div class="registIndex" @click="toRegist">注册</div> -->
              <a href="https://bcjyptxsd.xiongbangzhu.com/login?ot=1"><div class="loginBtn2">专属登录</div></a>
            </div>
            <!-- </div> -->
          </Col>
        </Row>
        <!-- 精选作品 -->
        <div class="works newOpus" v-if="featuredOpusList.length !== 0">
          <div class="new_tit_l">
            <img src="../assets/jing2.png" alt="" />
            <span>精选作品</span>
          </div>
          <Row :gutter="20">
            <Col span="6" v-for="(item, i) in featuredOpusList" :key="i" style="margin-bottom:.32rem">
              <div class="works_item">
                <div class="works_bg" @click="toOpusDetail(item)">
                  <!-- <img :src="item.opusCover" alt="" /> -->
                  <img :src="item.opusCover" alt="" />
                </div>
                <div class="info">
                  <h3>{{ item.opusName }}</h3>
                  <Row class="tools">
                    <Col span="7">
                      <div class="look">
                        <span>{{ item.viewNumber }}</span>
                      </div>
                    </Col>
                    <Col span="7">
                      <div :class="!item.isPraised ? 'disLike' : 'like'">
                        <span>{{ item.praiseNumber }}</span>
                      </div>
                    </Col>
                    <Col span="7">
                      <div :class="!item.isCollectioned ? 'disCollect' : 'collect'">
                        <span>{{ item.collectionNumber }}</span>
                      </div>
                    </Col>
                  </Row>
                  <div class="author">
                    <Avatar :src="item.studentAvatar"></Avatar>
                    <span class="author_name">{{ item.studentName }}</span>
                    <span v-if="item.className"> ( {{ item.className }} )</span>
                    <span v-else></span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <!-- 编程小新星 -->
        <div v-if="newStarList.length !== 0">
          <div class="xinxing ">
            <div class="slide_discription">
              <img src="../assets/xinxing.png" alt="" />
              <span>最新动态</span>
              <div class="query">
                <!-- <a href="javascript:;" style="color: #76d18e;fontSize:.18rem">热度</a> -->
                <a href="javascript:;" :class="isActiveHot ? 'active' : ''" @click="hotSearch">热门</a>
                <span style="color: #ccc;marginRight:.14rem">|</span>
                <a href="javascript:;" :class="isActiveTime ? 'active' : ''" @click="timeSearch">最新</a>
                <!-- <a href="javascript:;" style="color: #666;fontSize:.18rem">时间</a> -->
              </div>
            </div>
            <Row>
              <Col :span="24" v-for="(item, i) in newStarList" :key="i" class="reference_item" @click.native="toArtical(item, i)">
                <div class="refer" :gutter="42">
                  <div class="refer_l"><img :src="item.cover" class="refer_img" style="width:2.62rem;" /></div>
                  <div class="refer_r">
                    <h3>
                      <img src="../assets/yuan.png" v-if="item.sendRole === 1" alt="" class="yuan" />
                      <img src="../assets/guan.png" v-else-if="item.sendRole === 2" alt="" />
                      <img src="../assets/jing.png" v-if="item.goodsStatus" alt="" :class="item.goodsStatus === 1 ? 'jing' : 'hide'" />
                      {{ item.title }}
                    </h3>
                    <p>{{ item.programNewStarAbstract }}</p>
                    <div class="time">
                      <div class="timeL">
                        <Avatar :src="item.userAvatar" v-if="item.userAvatar !== 'undefined'"></Avatar
                        ><Avatar v-else src="https://dy-static.oss-cn-beijing.aliyuncs.com/students/img/IMG_0485.JPG"></Avatar><span class="txt">{{ item.signature }}</span
                        ><i>{{ item.createTime }}</i>
                      </div>
                      <Row class="tools">
                        <Col span="6">
                          <div class="look">
                            <span>{{ item.viewNumber }}</span>
                          </div>
                        </Col>
                        <Col span="12">
                          <!-- <div :class="item.isCollectioned ? 'collect' : 'disCommond'" @click="toCollect(i)"> -->
                          <div class="disCommond">
                            <span>{{ item.commentsNumber }}</span>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <div class="more" @click="loadingMore">{{ moreText }}</div>
        </div>
      </div>
      <div class="footer">
        <div class="address">
          <div>
            地址：深圳市南山区粤海街道海珠社区海德三道15号海岸大厦东座14BR02
          </div>
          <div class="copyRight">版权所有 深圳三点一四教育科技有限公司</div>
        </div>
        <div class="beiAnNum" @click="toCopyRight">粤ICP备18155800号-3</div>
      </div>
      <!-- 登录框 -->
      <Modal v-model="socialLogining">
        <Row class="login-form login" @keydown.enter.native="submitLogin">
          <Tabs @on-click="handleTabs" v-model="tabName">
            <TabPane label="账户密码登录" name="username">
              <Form ref="usernameLoginForm" :model="form" :rules="rules" class="form" v-if="tabName == 'username'">
                <FormItem prop="username">
                  <Input v-model="form.username" size="large" clearable placeholder="请输入用户名" autocomplete="off" />
                </FormItem>
                <FormItem prop="password">
                  <Input type="password" v-model="form.password" size="large" clearable placeholder="请输入密码" autocomplete="off" />
                </FormItem>
              </Form>
              <Row>
                <Button class="login-btn" type="primary" size="large" @click="submitLogin">
                  <span v-if="!loading">登录</span>
                  <span v-else>登录中...</span>
                </Button>
              </Row>
              <Row type="flex" justify="end">
                <!-- <Checkbox v-model="saveLogin" size="large" class="cwhite">自动登录</Checkbox> -->
                <!-- <a class="forget-pass cwhite" @click="handleDropDown">
                  忘记密码
                </a> -->
                <!-- <Dropdown trigger="click" @on-click="handleDropDown">
                  
                  <DropdownMenu slot="list">
                    <DropdownItem name="resetByMobile">使用手机号重置密码</DropdownItem>
                  </DropdownMenu>
                </Dropdown> -->
              </Row>
            </TabPane>
            <!-- <TabPane label="微信小程序扫码登录" name="wxLogon">
              <div @click="handleWxLogon" class="wxLogon">
                <qriously :value="baseUrlCode" :size="220" />
              </div>
              <div class="wxLogon_title">
                {{  checkCode == 9991 ? '请使用微信小程序扫码登录' :checkCodeType[checkCode] }}
              </div>
            </TabPane> -->
          </Tabs>
        </Row>
        <div slot="footer"></div>
      </Modal>
      <!-- 注册框 -->
      <Modal v-model="registModal">
        <Row class="regist-form">
          <Form ref="registForm" :model="registForm" :rules="registRules" class="registForm">
            <span class="regist-title">
              注册账号
            </span>
            <FormItem prop="username">
              <Input v-model="registForm.username" :maxlength="30" size="large" clearable placeholder="请输入用户名" />
            </FormItem>
            <FormItem prop="password">
              <Poptip trigger="focus" placement="right" width="250">
                <Input type="password" :maxlength="20" v-model="registForm.password" @on-change="strengthChange" size="large" clearable placeholder="请输入密码，长度为6-20个字符" />
                <div v-bind:class="tipStyle" slot="content">
                  <span class="words">强度 : {{ strength }}</span>
                  <Slider v-model="strengthValue" :step="33" style="width:95%"></Slider>
                  请至少输入 6 个字符。请不要使<br />用容易被猜到的密码。
                </div>
              </Poptip>
            </FormItem>
            <FormItem prop="confirmPass">
              <Input type="password" :maxlength="20" v-model="registForm.confirmPass" size="large" clearable placeholder="请再次输入确认密码" />
            </FormItem>
            <Form ref="verifyMobile" :model="registForm" :rules="rules" class="registForm">
              <FormItem prop="mobile">
                <Input v-model="registForm.mobile" size="large" clearable placeholder="请输入手机号">
                  <Select v-model="select" slot="prepend" style="width: 70px">
                    <Option value="86">+86</Option>
                  </Select>
                </Input>
              </FormItem>
              <FormItem prop="verifyCode" :error="errorCode">
                <Row type="flex" justify="space-between">
                  <Input v-model="registForm.verifyCode" size="large" clearable placeholder="请输入短信验证码" :maxlength="10" class="input-verify" />
                  <Button size="large" type="success" @click="sendVerify" v-if="!sended" class="send-verify">获取验证码</Button>
                  <Button size="large" disabled v-if="sended" class="count-verify">{{ countButton }}</Button>
                </Row>
              </FormItem>
            </Form>
          </Form>
          <Row type="flex" justify="space-between">
            <Button class="regist-btn" type="primary" size="large" :loading="loading" @click="submitRegist">
              <span v-if="!loading">注册</span>
              <span v-else>注册中...</span>
            </Button>
            <a class="to-login" @click="useAcountLogin">使用已有账号登录</a>
          </Row>
        </Row>
        <div slot="footer"></div>
      </Modal>
      <!-- 注册成功的模态框 -->
      <Modal v-model="registSucessModal">
        <Row class="success">
          <Icon type="md-checkmark-circle" color="#52c41a" size="64"></Icon>
          <p class="success-words">恭喜您，您的账户：{{ registForm.username }} 注册成功</p>
          <Row class="buttons">
            <Button type="primary" size="large" style="margin-right:10px;" @click="quickLogin">立即登录</Button>
            <Button size="large" @click="toRegist">返回注册</Button>
          </Row>
        </Row>
        <div slot="footer"></div>
      </Modal>
      <!-- 重置密码 -->
      <Modal v-model="resetPassworModal">
        <ResetPassword :type="type" @handleResetModal="handleResetModal">
          <div slot="back">
            <Row type="flex">
              <a @click="backLogin" class="back"> <Icon type="md-arrow-round-back" style="margin-bottom:3px;" /> 返回</a>
            </Row>
          </div>
        </ResetPassword>
      </Modal>
    </div>
  </div>
</template>
<script>
// window.addEventListener('resize', () => {
//   window.history.go(0)
// })
import loadingPage from './student/components/loading.vue'
import { getFeaturedOpusList, getProgramNewStarList, login, userInfo, getAdListByType, initCaptcha, regist, drawCodeImage, 
// wxLogin 
} from '@/api/index'
import util from '@/libs/util'
import { getRequest, postRequest } from '@/libs/axios'
import { removeStore } from '@/libs/storage'
import ResetPassword from './student/components/mobileResetPassword.vue'
// import wxlogin from 'vue-wxlogin'
import axios from 'axios'
export default {
  components: { ResetPassword, 
  // wxlogin, 
  loadingPage },
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码长度不得小于6位'))
      } else {
        callback()
      }
    }
    const validateConfirmPass = (rule, value, callback) => {
      if (value.length < 6) {
        callback(new Error('密码长度不得小于6位'))
      } else if (value !== this.registForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    const validateMobile = (rule, value, callback) => {
      var reg = /^[1][3,4,5,6,7,8][0-9]{9}$/
      if (!reg.test(value)) {
        callback(new Error('手机号格式错误'))
      } else {
        callback()
      }
    }
    return {
      dropZoneBorderColor:'',
      checkNumber: 0,
      checkCode: '',
      checkCodeType: {
        9990: '二维码已失效，请点击二维码重新刷新',
        9992: '扫描成功，请选择登录账号或点击确定',
        9993: '已取消登录',
        9994: '账号已到期,无法登录,请点击二维码重新刷新，并更换学生登录',
        200: '扫描成功，正在登录中~~~'
      },
      intervalName: '',
      baseUrlCode: '',

      wechatModal: false,
      loadingWechat: false,
      appid: 'wxf59525f72b7b7cac',
      scope: 'snsapi_login',
      state: '',
      style: 'black',
      redirect_uri: '',
      href: 'https://dy-static.oss-cn-beijing.aliyuncs.com/students/css/qrLogin.css',
      type: '',
      resetPassworModal: false,
      registSucessModal: false,
      registModal: false,
      loginText: '登录',
      moreText: '加载更多',
      category: 1,
      adList: [],
      featuredOpusList: [],
      // 获取小新星列表参数
      newStarQuery: {
        pageNumber: 1,
        pageSize: 4
      },
      newStarList: [],
      isShowLogin: false,
      show: false,
      getPath: '',
      socialLogining: false,
      tabName: 'username',
      saveLogin: false,
      sending: false,

      maxLength: 6,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          {
            required: true,
            message: '账号不能为空',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          }
        ]
      },
      isActiveTime: true,
      isActiveHot: false,
      pageIndex: 1,
      totalLength: 0,
      // 注册
      captchaId: '',
      verifyCodeImg: '',
      error: false,
      errorMsg: '',
      loading: false,
      loadingCode: true,
      sended: false,
      count: 60,
      countButton: '60 s',
      tipStyle: 'password-tip-none',
      strength: '无',
      select: '86',
      strengthValue: 0,
      errorCode: '',
      registForm: {
        username: '',
        password: '',
        confirmPass: '',
        mobile: '',
        verifyCode: '',
        verify: ''
      },
      registRules: {
        username: [
          {
            required: true,
            message: '账号不能为空',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '密码不能为空',
            trigger: 'blur'
          },
          {
            validator: validatePassword,
            trigger: 'blur'
          }
        ],
        confirmPass: [
          {
            required: true,
            message: '确认密码不能为空',
            trigger: 'blur'
          },
          {
            validator: validateConfirmPass,
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: 'blur'
          }
        ],
        verify: [
          {
            required: true,
            message: '验证码不能为空',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch:{
    socialLogining(){
      if(!this.socialLogining){
        this.tabName = 'username';
        this.checkCode = '';
        this.checkNumber = 0;
        clearInterval(this.intervalName);
      };
    },
    checkNumber(){
      if(this.checkNumber >= 120){
        this.checkCode = 9990;
        clearInterval(this.intervalName);
      };
    }
  },
  created() {
    this._getFeaturedOpusList()
    this._getProgramNewStarList(this.newStarQuery)
    this._getAdListByType({ category: 1 })
    if (util.localGet('accessToken')) {
      this.loginText = '去往主页'
    }
  },
  mounted() {
    let isRemoveToken= window.localStorage.getItem('isRemoveToken')
    if(isRemoveToken=='null'){
      window.localStorage.removeItem('userInfo')
      window.localStorage.removeItem('accessToken')
    }
    
    if(this.$route.query.accessToken){
      util.localSet('accessToken', this.$route.query.accessToken)
      this.toLogin()
    }
    
   
    let openid = this.$route.query.o
    let errMsg = this.$route.query.m
    if (errMsg) {
      this.$Message.error(errMsg)
    }
    if (openid) {
      this.loadingWechat = true
      // this.wxLogin(openid)
    }
  },
  methods: {
    handleResetModal(){
      this.resetPassworModal = false;
    },
    // 微信登录
    // async wxLogin(openid) {
    //   const get = (url, params) => {
    //     return axios({
    //       method: 'get',
    //       url: `${url}`,
    //       params: params
    //     })
    //   }
    //   const res = await get('/wx/getAccessToken', { openId: openid })
    //   if (res.success) {
    //     util.localSet('accessToken', res.result)
    //     this.toLogin()
    //   }
    // },
    async _getAppId() {
      const result = await postRequest('/v3/student/QRCodelogin/init', {}, true);
      if (result.success) {
        this.checkNumber = 0;
        this.baseUrlCode = result.result;
        this.handleActivityVerification();
      };
    },
    // 二维码活性校验
    handleActivityVerification(){
      this.intervalName = setInterval(async () => {
        const result = await postRequest('/v3/student/QRCodelogin/checkCode', { initCode: this.baseUrlCode }, true);
        this.checkCode = result.code;
        this.checkNumber += 1;
        if([9990,9993,9994,200].indexOf(result.code) != -1){ clearInterval(this.intervalName) };
        if(result.success){
          this.$util.localSet('accessToken', result.result);
          // 处理顶部頁签
          this.$store.state.app.pageOpenedList = [
            {
              title: '首页',
              path: '',
              name: 'home_index'
            }
          ];
          // 获取用户信息
          userInfo().then(res => {
            if (res.success === true) {
              this.$util.localSet('userInfo', res.result);
              this.$store.commit('setAvatarPath', res.result.avatar);
              // 加载菜单
              this.$util.initRouter(this)
              this.$router.push({
                name: 'home_index'
              })
            };
          });
        };
      }, 1000);
    },
    // 刷新二维码
    handleWxLogon(){
      if([9991,9992,200].indexOf(this.checkCode) != -1) return;
      clearInterval(this.intervalName);
      this._getAppId();
      this.$Message.success('已刷新二维码');
    },
    backLogin() {
      this.resetPassworModal = false
      this.socialLogining = true
    },
    // 忘记密码
    handleDropDown(v) {
      this.resetPassworModal = true
      this.socialLogining = false
      this.type = '0'
    },
    showAccount() {
      this.$Notice.info({
        title: '体验账号密码',
        desc: '账号1：test 密码：123456 <br>账号2：test2 密码：123456 已开放注册！',
        duration: 10
      })
    },
    // 千转k  万转w
    numConvert(num) {
      if (num >= 10000) {
        num = Math.round(num / 1000) / 10 + 'W'
      } else if (num >= 1000) {
        num = Math.round(num / 100) / 10 + 'K'
      }
      return num
    },
    // banner
    async _getAdListByType(id) {
      const res = await getAdListByType(id)
      if (res.success !== true) return false
      this.adList = res.result
      // this.adList =[]

    },
    // 精选作品
    async _getFeaturedOpusList() {
      const res = await getFeaturedOpusList()
      if (res.success !== true) return false
      if (res.result && res.result.length) {
        res.result[0].viewNumber = this.numConvert(3214 + res.result[0].viewNumber)
        res.result[0].praiseNumber = this.numConvert(765 + res.result[0].praiseNumber)
        res.result[0].collectionNumber = this.numConvert(58 + res.result[0].collectionNumber)
        if (res.result[1]) {
          res.result[1].viewNumber = this.numConvert(4321 + res.result[1].viewNumber)
          res.result[1].praiseNumber = this.numConvert(872 + res.result[1].praiseNumber)
          res.result[1].collectionNumber = this.numConvert(98 + res.result[1].collectionNumber)
        }
        if (res.result[2]) {
          res.result[2].viewNumber = this.numConvert(3765 + res.result[2].viewNumber)
          res.result[2].praiseNumber = this.numConvert(803 + res.result[2].praiseNumber)
          res.result[2].collectionNumber = this.numConvert(95 + res.result[2].collectionNumber)
        }
        if (res.result[3]) {
          res.result[3].viewNumber = this.numConvert(4651 + res.result[3].viewNumber)
          res.result[3].praiseNumber = this.numConvert(913 + res.result[3].praiseNumber)
          res.result[3].collectionNumber = this.numConvert(102 + res.result[3].collectionNumber)
        }
      }

      this.featuredOpusList = res.result
    },
    // 点击登录弹出登录框
    toLogin() {
      if (!util.localGet('accessToken')) {
        this.socialLogining = true
      } else {
        this.$store.state.app.pageOpenedList = [
          {
            title: '首页',
            path: '',
            name: 'home_index'
          }
        ]
        // 获取用户信息
        userInfo().then(res => {
          if (res.success === true) {
            this.$util.localSet('userInfo', res.result)
            this.$store.commit('setAvatarPath', res.result.avatar)
            // 加载菜单
            this.$util.initRouter(this)
            this.$router.push({
              name: 'home_index'
            })
          } else {
            this.loading = false
          }
        })
      }
    },
    // 进入作品详情
    toOpusDetail(item) {
      let index = this.featuredOpusList.indexOf(
        this.featuredOpusList.find(function(element) {
          return element.opusId === item.opusId
        })
      )
      let goodsToolsCount = {
        viewNumber: this.featuredOpusList[index].viewNumber,
        praiseNumber: this.featuredOpusList[index].praiseNumber,
        collectionNumber: this.featuredOpusList[index].collectionNumber
      }
      util.localSet('goodsToolsCount', goodsToolsCount)
      this.$router.push({
        name: 'opus-detail',
        query: {
          opusId: item.opusId
        }
      })
    },
    // 获取编程小新星列表
    async _getProgramNewStarList(obj) {
      const res = await getProgramNewStarList(obj)
      if (res.success !== true) return this.$Message.error(res.message)
      if (res.result && res.result.data.length) {
        res.result.data[0].viewNumber = 108 + res.result.data[0].viewNumber
        res.result.data[1].viewNumber = 118 + res.result.data[1].viewNumber
        res.result.data[2].viewNumber = 128 + res.result.data[2].viewNumber
        res.result.data[3].viewNumber = 108 + res.result.data[3].viewNumber
        this.newStarList = res.result.data
      }
    },
    // 按热度排序
    hotSearch() {
      // this.referObj.type = 'hot'
      this.isActiveHot = true
      this.isActiveTime = false
      this._getProgramNewStarList({ pageNumber: 1, pageSize: 4, type: 'hot' })
    },
    // 按时间排序
    timeSearch() {
      this.isActiveTime = true
      this.isActiveHot = false
      this._getProgramNewStarList({ pageNumber: 1, pageSize: 4 })
    },
    async loadingMore() {
      if (this.newStarList.length === this.totalLength) return (this.moreText = '没有更多数据了~')
      this.moreText = '加载中...'
      this.loading = true
      this.pageIndex += 1
      let params = {
        pageNumber: this.pageIndex,
        pageSize: 4
      }
      const res = await getProgramNewStarList(params)
      this.loading = false
      if (!res.success) return this.$Message.error(res.message)
      this.newStarList = this.newStarList.concat(res.result.data)
      this.totalLength = res.result.total
      if (this.newStarList.length !== this.totalLength) return (this.moreText = '加载更多')
      this.moreText = '没有更多数据了~'
    },
    // 进入文章详情
    toArtical(item, i) {
      this.$router.push({
        name: 'artical-detail',
        query: {
          id: item.id
        }
      })
      util.localSet('aticalViewnum', this.newStarList[i].viewNumber)
    },
    // 切换tab
    handleTabs(e) {
      if (e === 'wxLogon') {
        this.wechatModal = true
        this._getAppId()
      }else{
        clearInterval(this.intervalName);
      };
    },
    submitLogin() {
      this.$refs.usernameLoginForm.validate(valid => {
        if (valid) {
          this.loading = true
          login({
            username: this.form.username.trim(),
            password: this.form.password.trim(),
            // saveLogin: this.saveLogin,
            // // PLJ ： 验证码
            // verify: this.form.verify,
            // captchaId: this.captchaId
          }).then(res => {
            if (res.success === true) {
              this.$util.localSet('accessToken', res.result)
              this.$util.localSet('loginFrom', 1)
              // 处理顶部頁签
              this.$store.state.app.pageOpenedList = [
                {
                  title: '首页',
                  path: '',
                  name: 'home_index'
                }
              ]
              console.log('submitLogin');
              // 获取用户信息
              userInfo().then(res => {
                if (res.success === true) {
                  this.$util.localSet('userInfo', res.result);
                  this.$store.commit('setAvatarPath', res.result.avatar);
                  this.$util.initRouter(this)
                  this.$router.push({
                    name: 'home_index'
                  })
                  // 加载菜单
                  // if (res.result.userInfo.userType === 2 || res.result.userInfo.userType === -1) {
                  //   this.$util.initRouter(this)
                  //   this.$router.push({
                  //     name: 'home_index'
                  //   })
                  // } else {
                  //   this.$Message.info('抱歉，您不是学生账号')
                  //   removeStore('accessToken')
                  //   this.$router.push('/login')
                  //   this.loading = false
                  //   this.socialLogining = false
                  // }
                } else {
                  this.loading = false
                }
              })
            } else {
              // PLJ 验证码错误，提示信息
              if (res.code === 10001 || res.code === 10002) {
                this.$Message.error(res.message)
              }
              this.loading = false
            }
          })
        }
      })
    },
    quickLogin() {
      this.loading = true
      login({
        username: this.registForm.username,
        password: this.registForm.password
        // saveLogin: this.saveLogin
      }).then(res => {
        if (res.success === true) {
          this.$util.localSet('accessToken', res.result)
          // 处理顶部頁签
          this.$store.state.app.pageOpenedList = [
            {
              title: '首页',
              path: '',
              name: 'home_index'
            }
          ]
          console.log('quickLogin');
          // 获取用户信息
          userInfo().then(res => {
            if (res.success === true) {
              this.$util.localSet('userInfo', res.result);
              this.$store.commit('setAvatarPath', res.result.avatar);
              // 加载菜单
              this.$util.initRouter(this)
              this.$router.push({
                name: 'home_index'
              })
            } else {
              this.loading = false
            }
          })
        } else {
          // PLJ 验证码错误，提示信息
          if (res.code === 10001 || res.code === 10002) {
            this.$Message.error(res.message)
          }
          this.loading = false
        }
      })
    },
    // banner图如果有链接可点击
    handleAd(item) {
      if (!item.adLink) return
      window.open(item.adLink)
    },
    // 注册-----------------------------------
    toRegist() {
      this.registModal = true
      this.socialLogining = false
      this.registSucessModal = false
    },
    useAcountLogin() {
      this.registModal = false
      this.socialLogining = true
    },
    showErrorMsg(msg) {
      this.error = true
      this.errorMsg = msg
    },
    checkStrengthValue(v) {
      // 评级制判断密码强度 最高5
      let grade = 0
      if (/\d/.test(v)) {
        grade++ //数字
      }
      if (/[a-z]/.test(v)) {
        grade++ //小写
      }
      if (/[A-Z]/.test(v)) {
        grade++ //大写
      }
      if (/\W/.test(v)) {
        grade++ //特殊字符
      }
      if (v.length >= 10) {
        grade++
      }
      return grade
    },
    strengthChange() {
      if (!this.registForm.password) {
        this.tipStyle = 'password-tip-none'
        this.strength = '无'
        this.strengthValue = 0
        return
      }
      let grade = this.checkStrengthValue(this.registForm.password)
      if (grade <= 1) {
        this.tipStyle = 'password-tip-weak'
        this.strength = '弱'
        this.strengthValue = 33
      } else if (grade >= 2 && grade <= 4) {
        this.tipStyle = 'password-tip-middle'
        this.strength = '中'
        this.strengthValue = 66
      } else {
        this.tipStyle = 'password-tip-strong'
        this.strength = '强'
        this.strengthValue = 100
      }
    },
    sendVerify() {
      this.$refs.verifyMobile.validate(async valid => {
        if (valid) {
          // 发送短信验证码
          const result = await getRequest('/v3/student/sendSms/' + this.registForm.mobile, {}, true)
          if (result.success) {
            this.$Message.success(result.message)
          }
          this.sended = true
          this.countDown()
        }
      })
    },
    countDown() {
      let that = this
      if (this.count == 0) {
        this.sended = false
        this.count = 60
        return
      } else {
        this.countButton = this.count + ' s'
        this.count--
      }
      setTimeout(function() {
        that.countDown()
      }, 1000)
    },
    submitRegist() {
      this.$refs.registForm.validate(valid => {
        if (valid) {
          if (this.registForm.verifyCode === '') {
            this.errorCode = '验证码不能为空'
            return
          } else {
            this.errorCode = ''
          }
          this.loading = true
          this.registForm.captchaId = this.captchaId
          this.registForm.passStrength = this.strength
          regist(this.registForm).then(res => {
            this.loading = false
            if (res.success) {
              // let query = {
              // username: this.registForm.username
              // }
              this.registModal = false
              this.registSucessModal = true
              // this.$router.push({
              //   name: 'regist-result',
              //   query: query
              // })
            };
          })
        }
      })
    },
    // 不需要 动态验证码
    // getVerifyCode() {
    //   this.loadingCode = true
    //   initCaptcha().then(res => {
    //     if (res.success) {
    //       this.captchaId = res.result.captchaId
    //       this.verifyCodeImg = drawCodeImage + this.captchaId
    //       this.loadingCode = false
    //     }
    //   })
    // },
    toCopyRight() {
      window.open('http://beian.miit.gov.cn/', '_blank')
    }
  },
  destroyed(){
    clearInterval(this.intervalName);
  },
}
</script>
<style lang="less" scoped>
@import './index.less';
.upload-dragger {
      font-size: 12px;
      background-color: #fff;
      border: 1px solid #d9dbde;
      border-radius: 8px;
      width: 200px;
      height: 200px;
      text-align: center;
      cursor: pointer;
      position: relative;
    }

    .upload-dragger .upload-center {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
.wxLogon {
  margin-top: -0.3rem;
  height: 250px;
  display: flex;
  justify-content: center;
  align-content: center;
}
.wxLogon_title{
  width: 100%;
  margin: 5px 0;
  text-align: center;
}
.wxBindModal {
  height: calc(100vh);
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 9999;
  background-color: #333;
  .title {
    color: #fff;
    text-align: center;
    margin-top: 100px;
    font-size: 16px;
  }
  .liucheng {
    width: 50%;
    margin: 0 auto;
    display: flex;
    margin-top: 100px;
    justify-content: space-around;
    > div {
      width: 20%;
      color: #fff;
      font-size: 12px;
    }
  }
  .tip {
    width: 250px;
    padding-top: 10px;
    padding-bottom: 10px;
    margin: 0 auto;
    text-align: center;
    background-color: #232323;
    color: #fff;
    font-size: 14px;
    border-radius: 48px;
    box-shadow: 0 -1px 0px #999 inset;
  }
  .wxMp {
    width: 200px;
    height: 200px;
    display: inline-block;
    text-align: center;
    p {
      color: #fff;
    }
    img {
      width: 100%;
    }
  }
  .qrcode {
    display: inline-block;
    text-align: center;
    p {
      color: #fff;
    }
  }
  .btn {
    display: inline-block;
    height: 200px;
    width: 300px;
    position: relative;
    span {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      padding: 10px 20px;
      border-radius: 20px;
      font-size: 14px;
      color: #fff;
      background-color: #2d8cf0;
      cursor: pointer;
    }
  }
}
/deep/.ivu-tabs-nav .ivu-tabs-tab .ivu-icon {
  width: 14px;
  height: 14px;
  margin-right: 8px;
  margin-bottom: 5px;
}
/deep/div.ivu-tabs-tab {
  height: 0.5rem;
  color: #666;
}
/deep/ .ivu-modal-body {
  padding-left: 0.4rem;
  padding-right: 0.4rem;
}
/deep/ .ivu-modal-footer {
  display: none !important;
}
// /deep/ .ivu-tabs-nav .ivu-tabs-tab-active{
//   color: red!important;
// }
/deep/ .ivu-tabs-tab:hover {
  color: #76d18e;
}
/deep/ .ivu-tabs-ink-bar {
  height: 0.03rem;
  background-color: #76d18e;
  bottom: -0.014rem;
}
/deep/div.ivu-tabs-tab.ivu-tabs-tab-active.ivu-tabs-tab-focused {
  color: #333 !important;
}
/deep/ .ivu-tabs-nav-container {
  height: 0.5rem;
  line-height: 1.6em;
}
/deep/ .ivu-input-large {
  height: 0.44rem;
}
/deep/ .ivu-form-item {
  margin-bottom: 0.3rem;
}
/deep/ .ivu-tabs-content {
  margin-top: 0.35rem;
}
/deep/ .ivu-input-wrapper {
  width: 99%;
  margin-left: 0.01rem;
}
/deep/ .ivu-modal {
  top: 2.8rem;
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue